import { Component, Watch, Vue, Prop } from 'vue-property-decorator';
import moment from 'moment';
import type { CreateElement } from 'vue';
import NewSelectSite from '../newSelectSIte';
import AddVideo from './addVideo.vue';
import { IPSService } from '@/services/ipsServices';
import { noop } from '@/util';

export const VideoStateList = [
  { label: '全部', value: 9 },
  { label: '待发布', value: 1 },
  { label: '已发布', value: 2 },
  { label: '已过期', value: 3 },
  { label: '已下架', value: 4 },
];

export enum AD_STATE {
  ALL = 9,
  RELEASED = 1, // 待发布
  PUBLISHED, // 已发布
  EXPIRED, // 已过期
  WITHDRAWN, // 已下架
}

export const AdStateText = {
  [AD_STATE.ALL]: '全部',
  [AD_STATE.RELEASED]: '待发布',
  [AD_STATE.PUBLISHED]: '已发布',
  [AD_STATE.EXPIRED]: '已过期',
  [AD_STATE.WITHDRAWN]: '已下架',
};

@Component({
  components: { AddVideo },
})
export default class VideoTable extends Vue {
  @Prop({ default: {} })
    postParams: ItemObject;

  page = 1;

  pageSize = 10;

  totalCount = 0;

  keyword = '';

  videoState = '';

  tableData: Array<VideoListItem> = [];

  videoStateList = VideoStateList;

  loadingState = false;

  empCode = null;

  showAddDialog = false;

  videoId = 0;

  readOnly = false;

  date = [];

  public defaultStart: Date;

  public defaultEnd: Date;

  @Watch('postParams', { deep: true })
  watchPostParams() {
    this.page = this.postParams.page;
    this.pageSize = this.postParams.pageSize;
    this.keyword = this.postParams.keyword;
    if (this.postParams.parentId) {
      this.getTableData();
    } else {
      this.tableData = [];
      this.totalCount = 0;
      this.page = 1;
      this.pageSize = 10;
      this.keyword = '';
      this.$emit('loadingClose');
    }
  }

  mounted() {
    this.empCode = this.$store.state.empCode;
  }

  getTableData() {
    this.loadingState = true;
    const postParams = {
      sgId: this.postParams.sgId,
      sgwpId: this.postParams.sgwpId,
      keyword: this.keyword,
      videoState: Number(this.videoState) || 9,
      page: this.page,
      pageSize: this.pageSize,
    };
    IPSService.gsVideoList({
      postParams,
    })
      .then((response) => {
        this.tableData = response.list || [];
        this.totalCount = response.count || 0;
        this.loadingState = false;
        this.$emit('loadingClose');
      })
      .catch((error) => {
        this.loadingState = false;
        this.$emit('loadingClose');
      });
  }

  //   获取详情
  handleCheck(videoId) {
    this.videoId = videoId;
    this.readOnly = true;
    this.showAddDialog = true;
  }

  //   编辑
  handleEdit(videoId) {
    this.videoId = videoId;
    this.readOnly = false;
    this.showAddDialog = true;
  }

  handleSearch() {
    if (this.postParams.parentId) {
      this.getTableData();
    }
  }

  handleAddAd() {
    this.videoId = 0;
    this.readOnly = false;
    this.showAddDialog = true;
  }

  //   删除
  handleDel(videoId) {
    this.$confirm('是否删除该视频？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      closeOnClickModal: false,
      type: 'warning',
    }).then((res) => {
      if (res === 'confirm') {
        IPSService.gsVideoDelete({
          postParams: {
            videoId,
          },
        })
          .then((response) => {
            this.$message.success('删除成功');
            this.page = 1;
            this.getTableData();
          })
          .catch((error) => {
            this.$message.error('删除失败');
          });
      }
    }, noop);
  }

  onSizeChange(val) {
    this.page = 1;
    this.pageSize = val;
    this.getTableData();
  }

  onPageChange(val) {
    this.page = val;
    this.getTableData();
  }

  //   选择状态
  selectChange(val) {
    this.videoState = val;
    this.getTableData();
  }

  renderFilter(h: CreateElement) {
    return (
      <div class="filterController">
        <div class="inputWrapper wid-100">
          <el-input v-model={this.keyword} placeholder="视频标题" onEnter={this.handleSearch.bind(this)} disabled={!this.postParams.parentId} />
          <i class="iconfont iconsousuo" onClick={this.handleSearch.bind(this)} />
        </div>
        <el-select v-model={this.videoState} onChange={this.selectChange.bind(this)} disabled={!this.postParams.parentId}>
          {Object.keys(AdStateText).map((v, i) => {
            return <el-option key={`${v}${i}`} value={v} label={AdStateText[v]} />;
          })}
        </el-select>
      </div>
    );
  }

  /**
   * 操作栏按钮
   * @param h
   * @param row
   */
  renderTableBtn(h, row) {
    const { videoState, videoId, operAuthority } = row;
    if (!operAuthority || videoState === AD_STATE.EXPIRED) {
      return (
        <p>
          <span class="scopeSpan" onClick={this.handleCheck.bind(this, videoId)}>
            查看
          </span>
        </p>
      );
    }
    return (
      <p>
        {(videoState === AD_STATE.RELEASED || videoState === AD_STATE.PUBLISHED || videoState === AD_STATE.WITHDRAWN) && (
          <span class="scopeSpan" onClick={this.handleEdit.bind(this, videoId)}>
            编辑
          </span>
        )}
        {(videoState === AD_STATE.RELEASED || videoState === AD_STATE.PUBLISHED) && (
          <span class="scopeSpan" onClick={this.handleChangeState.bind(this, videoId, 0)}>
            下架
          </span>
        )}
        {videoState === AD_STATE.WITHDRAWN && (
          <span class="scopeSpan" onClick={this.handleChangeState.bind(this, videoId, 1)}>
            上架
          </span>
        )}
        <span class="scopeSpan" onClick={this.handleDel.bind(this, videoId)}>
          删除
        </span>
      </p>
    );
  }

  //   修改状态
  handleChangeState(videoId, videoState) {
    this.$confirm(`是否${videoState ? '上' : '下'}架该视频？`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      closeOnClickModal: false,
      type: 'warning',
    }).then((res) => {
      if (res === 'confirm') {
        IPSService.gsVideoStateUpdate({
          postParams: {
            videoId,
            videoState,
          },
        }).then(
          (res) => {
            if (res.result) {
              this.$message.success(`${videoState === 1 ? '上架' : '下架'}成功`);
              this.getTableData();
            } else {
              this.$message.error(`${videoState === 1 ? '上架' : '下架'}失败`);
            }
          },
          () => {
            this.$message.error(`${videoState === 1 ? '上架' : '下架'}失败`);
          },
        );
      }
    }, noop);
  }

  renderBottomButton(h: CreateElement) {
    return (
      <div class="bottomWrapper">
        <el-button type="primary" onClick={this.handleAddAd.bind(this)} disabled={!this.postParams.parentId}>
          追加视频
        </el-button>
        {this.postParams.parentId && (
          <el-pagination
            disabled={!this.postParams.parentId}
            on-size-change={e => this.onSizeChange(e)}
            on-current-change={e => this.onPageChange(e)}
            currentPage={this.page}
            pageSizes={[10, 15, 20, 30]}
            pageSize={this.pageSize}
            layout="total, sizes, prev, pager, next, jumper"
            total={this.totalCount}
          />
        )}
      </div>
    );
  }

  onSave() {
    this.showAddDialog = false;
    this.page = 1;
    this.getTableData();
  }

  renderTable(h: CreateElement) {
    return (
      <el-table class="tableWrapper el-table" element-loading-text="加载中" width="100%" height="calc(100% - 107px)" v-loading={this.loadingState} data={this.tableData} tooltip-effect="light">
        <el-table-column type="index" label="ID" align="center" />
        <el-table-column prop="videoName" label="视频标题" show-overflow-tooltip />
        <el-table-column
          prop="siteCodes"
          label="适用网点"
          align="center"
          {...{
            scopedSlots: {
              default: (scope) => {
                return (
                  <span
                    class="scopeSpan"
                    onClick={() => {
                      new NewSelectSite().open({
                        sgId: this.postParams.parentId,
                        selectCodes: scope.row.siteCodes.map((i) => {
                          return typeof i !== 'string' ? i.siteCode : i;
                        }),
                        readonly: true,
                      }).then(noop, noop);
                    }}>
                    {scope.row.siteCodes.length}
                  </span>
                );
              },
            },
          }}
        />
        <el-table-column
          prop="beginTime"
          label="有效期"
          align="left"
          width="200"
          show-overflow-tooltip
          {...{
            scopedSlots: {
              default: (scope) => {
                if (scope.row.beginTime && scope.row.endTime) {
                }
                if (scope.row.beginTime == 0 && scope.row.endTime == 0) {
                  return '长期有效';
                }
                return `${moment(scope.row.beginTime * 1000).format('YYYY-MM-DD HH:mm')}~${moment(scope.row.endTime * 1000).format('YYYY-MM-DD HH:mm')}`;
                // return (
                //   moment(scope.row.advBeginTime * 1000).format("YYYY-MM-DD HH:mm") +
                //   "~" +
                //   moment(scope.row.advEndTime * 1000).format("YYYY-MM-DD HH:mm")
                // );
              },
            },
          }}
        />
        <el-table-column
          prop="videoState"
          label="状态"
          align="center"
          width="80"
          {...{
            scopedSlots: {
              default: (scope) => {
                return AdStateText[scope.row.videoState];
              },
            },
          }}
        />
        <el-table-column prop="updatePerson" label="更新人" align="center" />
        <el-table-column
          prop="updateTime"
          label="更新时间"
          width="180px"
          show-overflow-tooltip
          {...{
            scopedSlots: {
              default: (scope) => {
                return moment(scope.row.updateTime * 1000).format('YYYY-MM-DD HH:mm');
              },
            },
          }}
        />
        <el-table-column
          align="center"
          label="操作"
          width="150"
          fixed="right"
          {...{
            scopedSlots: {
              default: (scope) => {
                return this.renderTableBtn(h, scope.row);
              },
            },
          }}
        />
      </el-table>
    );
  }

  render(h: CreateElement) {
    return (
      <div class="shopWindowContainer shop-ad new-display-config">
        <div class="windowList height-100">
          {this.renderFilter(h)}
          {this.renderTable(h)}
          {this.renderBottomButton(h)}
          <AddVideo v-model={this.showAddDialog} readOnly={this.readOnly} videoId={this.videoId} sgId={this.postParams.sgId} sgwpId={this.postParams.sgwpId} sgName={this.postParams.sgName} onSave={this.onSave.bind(this)}></AddVideo>
        </div>
      </div>
    );
  }
}
